
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coinflip",
      function () {
        return require("private-next-pages/coinflip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coinflip"])
      });
    }
  